import { render, staticRenderFns } from "./NewCategory.vue?vue&type=template&id=51f39183&"
import script from "./NewCategory.vue?vue&type=script&lang=ts&"
export * from "./NewCategory.vue?vue&type=script&lang=ts&"
import style0 from "./NewCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewCategory.vue"
export default component.exports